<template>
    <div>

        <v-dialog 
            v-model="disableDialog" 
            width="40%"
            elevation="8"
            persistent>
                <DisableProject 
                    :disableArgs="disableArgs"
                    :project_statuses="project_statuses"
                    @closeProject="closeProject"
                    @refreshProject="refreshProject"
                    @closeDisableDialog="closeDisableDialog"
                    @triggerUserFeedback="triggerUserFeedback" />
        </v-dialog> 

        <v-dialog 
            v-model="profileDialog" 
            transition="dialog-bottom-transition"
            max-width="83%"
            scrollable>
            <v-card>
                <v-card-title class="info pewter--text d-flex justify-end">
                    <!-- <div v-for="buyer in user_data" :key="buyer.user_id" class="">
                        <div class="justify-start mr-12">{{ buyer.first_name }} {{ buyer.last_name }}</div>
                        <div class="d-flex flex-grow-1">
                            <div class="justify-start mr-6">{{ buyer.user_email }}</div>
                            <v-divider v-if="buyer.phone" vertical class="pewter"></v-divider>
                            <div class="justify-center mx-6">{{ buyer.phone }}</div>
                            <v-divider v-if="buyer.city || buyer.state" vertical class="pewter"></v-divider>
                            <div class="justify-end ml-6">{{ buyer.city }}{{ buyer.city && buyer.state ? ', ': ' ' }}{{ buyer.state }}</div>
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="justify-end"> -->
                        <v-btn 
                            icon 
                            dark 
                            class="ml-3"
                            @click="closeQuestionnaire()">
                            <v-icon color="pewter">mdi-close</v-icon>
                        </v-btn>
                    <!-- </div> -->
                </v-card-title>
                <v-card-text>
                    <ModuleQuestionnaire 
                        v-if="readyToLoad"
                        :key="current_milliseconds"
                        :user_id="user_data[0].user_id"
                        :module_key="moduleKey"
                        :module_id="moduleId"
                        :project_id="projectId"
                        :isOpen="profileDialog"
                        :openQuestionnaire="openQuestionnaire"
                        @questionnaireProgressUpdated="applyQuestionnaireProgressUpdate"
                    />
                </v-card-text>
                <v-card-actions class="info">
                    <v-spacer></v-spacer>
                    <!-- <v-btn
                        outlined
                        color="pewter"
                        class="mr-3"
                        @click="buyerQuestionnaire_dialog = false">
                        close
                    </v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog 
            v-model="titleDialog" 
            transition="dialog-bottom-transition"
            width="50%">
            <v-card>
                <v-card-title class="primary darken-1 white--text">Add an internal title for this project.</v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="updateProject.internal_project_title"
                        class="my-4 pa-2"
                        label="Title"
                        single-line
                        :rules="updateProject.internal_project_title != null ? max100chars : []"
                        counter>
                    </v-text-field>
                    <div class="d-flex d-block justify-end">
                        <v-btn
                            class=""
                            color="primary"
                            :disabled="updateProject.internal_project_title == undefined || updateProject.internal_project_title.length > 100"
                            @click="updateProjectTitle(updateProject)">
                            Save
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog 
            v-model="videoDialog" 
            persistent
            width="55%"
            elevation="8">
            <v-card>
                <v-card-title class="headline primary darken-1 white--text d-flex justify-space-between">
                    {{ videoTitle }}
                    <v-btn
                        icon
                        @click="closeVideo()">
                        <v-icon 
                            class="white--text">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="py-6 align-center mx-auto">                    
                    <div v-if="videoValid === null || videoValid === false">
                        <v-progress-circular   
                            v-if="videoValid === null"
                            indeterminate
                            color="primary"
                            class="mx-auto my-12 py-12 d-block"
                            size="100"
                            width="5">
                        </v-progress-circular>

                        <div v-if="videoValid === false" class="d-block my-12 py-12 text-center sansation_title">
                            We're sorry, this video is not available at this time.
                        </div>
                    </div>

                    <VideoPlayer v-if="videoValid"
                        :key="videoUrl"
                        :video_id="videoUrl"
                        :video_src="videoSrc"
                        :video_type="videoType" />
                </v-card-text>
            </v-card>
        </v-dialog>

        <div class="d-flex py-5 px-6 d-block header_bg_color align-center justify-space-between">
            <div class="info--text font-weight-bold white--text">
                <UserData_Dashboard 
                    :key="project_id"
                    :user_data="client_info"
                    source="dashboard"
                />
            </div>

            <div class="justify-end">
                <v-btn 
                    icon
                    outlined
                    color="white"
                    elevation="1"
                    @click="closeProject(true)">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
        </div>

        <div v-if="relatedProjectLoading || !readyToLoad" class="d-flex justify-center align-center py-12 my-12" style="width: 100%">
            <v-progress-circular
                indeterminate 
                color="error darken-3" 
                size="190" 
                width="9"
                class="mt-12">
                ... project loading ...
            </v-progress-circular>
        </div>
        
        <div v-else>
            <div class="px-5 pt-5 d-flex d-block align-top justify-space-between">
                <div class="align-top">
                    <div class="d-flex align-center">
                        <customIcon v-if="project_details.modinfo.module_key && project_details.modinfo.module_key != ''" :name="project_details.modinfo.module_key" class="d-inline ml-n2 mr-1 info--text text--lighten-2 icon-size-header" />
                        <div class="d-inline info--text text--lighten-2 label_large">
                            <div class="d-inline">
                                {{ project_details.modinfo.module_name }}
                                {{ project_details.project_title != null && project_details.project_title != '' ? ` :: ` : `` }}
                                <span class="font-weight-thin grey--text">{{ project_details.project_title != null && project_details.project_title != '' ? project_details.project_title : '' }}</span>
                                {{ project_details.internal_project_title != null && project_details.internal_project_title != '' ? ` :: ` : `` }}
                                <span class="font-weight-thin grey--text text--darken-2">{{ project_details.internal_project_title != null && project_details.internal_project_title != '' ? project_details.internal_project_title : '' }}</span>
                            </div>
                            <v-icon
                                small
                                color="primary"
                                class="d-inline ml-2"
                                @click.stop.prevent="openProjectTitle(project_details)">
                                mdi-pencil
                            </v-icon>
                        </div>
                    </div>
                </div>
                    
                <div class="justify-space-between pt-2">
                <!-- @click.stop.prevent="exportResolutionData(project_details)"> -->
                    <div class="d-block text-right">
                        <v-btn
                            v-if="project_details.has_data || project_details.date_submitted"
                            small
                            outlined
                            color="primary"
                            class="mr-3 justify-end"
                            @click.stop.prevent="exportAnswers(project_details)">
                            Export Answers
                        </v-btn>
                        <v-btn
                            small
                            elevation=0
                            color="primary"
                            class="justify-end"
                            @click.stop.prevent="openQuestionnaire(project_details)">
                            View Questionnaire
                        </v-btn>
                        <v-btn
                            outlined
                            class="ml-1"
                            color="accent darken-1"
                            icon
                            @click.stop.prevent="questionnaireLocking(project_details)">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    v-bind="attrs"
                                    v-on="on">
                                        {{ project_details.questionnaire_locked ? 'mdi-lock' : 'mdi-lock-open-variant' }}
                                    </v-icon>
                                </template>
                                <span>click to {{ project_details.questionnaire_locked ? 'unlock' : 'lock' }}</span>
                            </v-tooltip>
                        </v-btn>
                    </div>
                    <div class="d-block text-right" v-if="project_details.questionnaire_progress">
                        <v-progress-linear
                            :value="questionnaire_percentage == 0 ? 1 : questionnaire_percentage"
                            color="accent darken-1"
                            class="pa-0 mx-0 mt-3 mb-0 justify-end" 
                            rounded
                            width="100"
                            height="5">
                        </v-progress-linear>
                        <div class="caption font-weight-thin justify-end mb-3">
                            {{ questionnaire_completed_sections+' of '+questionnaire_total_sections }} sections ({{ questionnaire_percentage }}%) complete
                        </div>
                    </div>
                </div>
            </div>

            <v-card-text class="my-0 py-0">
                <v-card outlined class="mt-1 mb-2 py-1 px-5 d-flex d-block align-center sansation menu_bg_primary">
                    
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'overview'" class="primary--text text--darken-1" @click="projectView('overview')">Overview</a>
                        <div v-if="project_detail_view == 'overview'" class="grey--text">Overview</div>
                    </div>

                    <v-divider vertical class="mx-5"></v-divider>
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'activity'" class="primary--text text--darken-1" @click="projectView('activity')">Activity</a>
                        <div v-if="project_detail_view == 'activity'" class="grey--text">Activity</div>
                    </div>
                    
                    <v-divider vertical class="mx-5"></v-divider>
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'docs'" class="primary--text text--darken-1" @click="projectView('docs')">Documents</a>
                        <div v-if="project_detail_view == 'docs'" class="grey--text">Documents</div>
                    </div>
                    
                    <v-divider vertical class="mx-5"></v-divider>
                    <div class="d-inline">
                        <a v-if="project_detail_view != 'users'" class="primary--text text--darken-1" @click="projectView('users')">Users</a>
                        <div v-if="project_detail_view == 'users'" class="grey--text">Users</div>
                    </div>

                    <v-divider v-if="project_details.modinfo.module_key && project_details.modinfo.module_key === 'entity-maintenance-program'" vertical class="mx-5"></v-divider>                    
                    <div class="d-inline" v-if="project_details.modinfo.module_key && project_details.modinfo.module_key === 'entity-maintenance-program'">
                        <a v-if="project_detail_view != 'resolutions'" class="primary--text text--darken-1" @click="projectView('resolutions')">
                            Resolutions <v-badge v-if="resolution_cnt > 0" color="primary" :content="resolution_cnt" class="mx-2"></v-badge>
                        </a>
                        <div v-if="project_detail_view == 'resolutions'" class="grey--text">
                            Resolutions <v-badge v-if="resolution_cnt > 0" color="grey" :content="resolution_cnt" class="mx-2"></v-badge>
                        </div>
                    </div>

                    <v-divider v-if="( project_details.modinfo.module_key && ( project_details.modinfo.module_key === 'entity-maintenance-program' || entityFilingModules.includes(project_details.modinfo.module_key)) )" vertical class="mx-5"></v-divider>                    
                    <div class="d-inline" v-if="( project_details.modinfo.module_key && ( project_details.modinfo.module_key === 'entity-maintenance-program' || entityFilingModules.includes(project_details.modinfo.module_key)) )">
                        <a v-if="project_detail_view != 'filing-data'" class="primary--text text--darken-1" @click="projectView('filing-data')">Filing Data</a>
                        <div v-if="project_detail_view == 'filing-data'" class="grey--text">Filing Data</div>
                    </div>

                    <v-divider v-if="project_details.show_psr" vertical class="mx-5"></v-divider>
                    <div class="d-inline" v-if="project_details.show_psr">
                        <a v-if="project_detail_view != 'report'" class="primary--text text--darken-1" @click="projectView('report')">PSR</a>
                        <div v-if="project_detail_view == 'report'" class="grey--text">PSR</div>
                    </div>

                    <v-divider v-if="project_details" vertical class="mx-5"></v-divider>
                    <div class="d-inline" v-if="project_details">
                        <a v-if="project_detail_view != 'team'" class="primary--text text--darken-1" @click="projectView('team')">Team</a>
                        <div v-if="project_detail_view == 'team'" class="grey--text">Team</div>
                    </div>
                    <v-spacer></v-spacer>

                    <div class="d-inline caption font-weight-thin primary--text text--darken-1">Test Project</div>
                    <v-switch
                        v-model="project_details.is_test"
                        flat
                        dense
                        hide-details
                        class="d-inline mx-3 mt-n1"
                        color="primary"
                        @change="flagProjectAsTest( project_details )" />
                                    
                    <div class="d-inline caption grey--text ml-6"
                        @click="handleCopyProjectId( project_details.project_id )">

                        <v-tooltip bottom content-class="contact_tooltip cursor-pointer">
                            <template v-slot:activator="{ on, attrs }">
                                <span 
                                    :id="`copy-pid-${project_details.project_id}`"
                                    class="font-weight-thin primary--text text--darken-1"
                                    v-bind="attrs"
                                    v-on="on">
                                    <v-icon 
                                        x-small 
                                        class="mr-1"
                                        color="primary darken-1">
                                        mdi-content-copy
                                    </v-icon>
                                    {{ project_details.project_id }}
                                </span>
                            </template>
                            <span>{{ trigger_copied ? 'copied' : 'click to copy' }}</span>
                        </v-tooltip>
                    </div>

                </v-card>

                <v-card v-if="project_detail_view == 'overview'" elevation="0" class="mt-6 pb-12">
                    <ProjectData
                        :projectDetails="project_details"
                        :project_calls="project_details.modinfo.calls_allowed"
                        :revision_opportunities="project_details.modinfo.revision_rounds"
                        :showCompletedDate="showCompletedDate"
                        :entity_filing_status_list="entity_filing_status_list"
                        :admin_document_status_list="admin_document_status_list"
                        :annual_report_filing_status_list="annual_report_filing_status_list"
                        :report_type_options_list="report_type_options_list"
                        :formatThisDate="formatThisDate"
                        @estCompletionDate="estCompletionDate"
                        @saveProject="saveProject"
                        @refreshUsers="refreshUsers"
                        @triggerUserFeedback="triggerUserFeedback"
                        @openRelatedProject="navigateToRelatedProject"
                        @closeProject="closeProject"
                        @thisProjectDetail="thisProjectDetail"
                        :refreshProjects="refreshProjects" />
                </v-card>

                <v-card v-if="project_detail_view == 'activity'" elevation="0" class="mt-6 pb-12">
                    <ActivityLogs
                        :projectID="project_details.project_id"
                        :userID="project_details.user_id"
                        @triggerUserFeedback="triggerUserFeedback" />
                </v-card>

                <v-card v-if="project_detail_view == 'report' && project_details.show_psr" elevation="0" class="mt-6 pb-12">
                    <ProjectReport
                        :projectDetails="project_details"
                        :formatThisDate="formatThisDate"
                    />
                </v-card>

                <v-card v-if="project_detail_view == 'docs'" elevation="0" class="mt-6 pb-12">
                    <ProjectFiles
                        :projectDetails="project_details"
                        :refresh_docs="refresh_docs"
                        :triggerUserFeedback="triggerUserFeedback"
                        :formatThisDate="formatThisDate"
                        @pullProjectDocs="pullProjectDocs" />

                    <div class="my-10">&nbsp;</div>

                                            <!-- v-if="project_details.users.some(usr => usr.user_type === 'partner')" -->
                    <ProjectPartnerDocs
                        :projectDetails="project_details"
                        :refresh_partner_docs="refresh_partner_docs"
                        :triggerUserFeedback="triggerUserFeedback"
                        :formatThisDate="formatThisDate"
                        @pullProjectDocs="pullProjectDocs" />

                    <div class="my-10">&nbsp;</div>
                    
                    <ProjectDeliverables
                        :projectDeliverables="project_details"
                        :refresh_delivs="refresh_delivs"
                        :triggerUserFeedback="triggerUserFeedback"
                        :formatThisDate="formatThisDate"
                        @pullProjectDelivs="pullProjectDelivs" />

                    <div class="my-10">&nbsp;</div>

                    <ProjectResources
                        :projectResources="project_details"
                        @toggleVisiblity="toggleVisiblity"
                        @playResourceVideo="playResourceVideo" />
                </v-card>

                <v-card v-if="project_detail_view == 'users'" elevation="0" class="mt-6 pb-12">
                    <ProjectUsers
                        :projectDetails="project_details"
                        :formatThisDate="formatThisDate"
                        @refreshUsers="refreshUsers" />
                </v-card>
                <v-card v-if="project_detail_view == 'resolutions' && ( project_details.modinfo.module_key && project_details.modinfo.module_key === 'entity-maintenance-program' )" elevation="0" class="mt-6 pb-12">
                    <ProjectResolutions
                        :projectDetails="project_details"
                        :projectStatuses="project_statuses.filter( status => resolutionStatuses.includes(status.value) )"
                        :subProjects="subProjects"
                        :calculateResolutionsUsed="calculateResolutionsUsed"
                        :formatThisDate="formatThisDate"
                        :openQuestionnaire="openQuestionnaire"
                        :pullProjectDelivs="pullProjectDelivs"
                        @getSubProjects="getSubProjects"
                        @triggerUserFeedback="triggerUserFeedback"
                    />
                </v-card>

                <v-card v-if="project_detail_view == 'filing-data' && ( project_details.modinfo.module_key && ( project_details.modinfo.module_key === 'entity-maintenance-program' || entityFilingModules.includes(project_details.modinfo.module_key)) )" elevation="0" class="mt-6 pb-12">
                    <EmpFilingData
                        :projectDetails="project_details"
                        :showCompletedDate="showCompletedDate"
                        :entityFilingModules="entityFilingModules"
                        :entity_filing_status_list="entity_filing_status_list"
                        :annual_report_filing_status_list="annual_report_filing_status_list"
                        :report_type_options_list="report_type_options_list"
                        :formatThisDate="formatThisDate"
                        @thisProjectDetail="thisProjectDetail"
                        @triggerUserFeedback="triggerUserFeedback"
                    />
                </v-card>

                <v-card v-if="project_detail_view == 'team'" elevation="0" class="mt-6 pb-12">
                    <ProjectTeam
                        :projectDetails="project_details"
                        :formatThisDate="formatThisDate"
                        @refreshUsers="refreshUsers" />
                </v-card>

            </v-card-text>
            <v-card-actions class="pa-4 d-flex justify-space-between" style="border-top: 1px solid #BDBDBD">
                <div class="d-inline">
                    <v-btn 
                        class="d-inline menu_bg_primary primary--text text--darken-1"
                        elevation=0
                        @click="initDisableProject(project_details)">
                        <v-icon color="primary" class="mr-3" left>{{ project_details.is_archived ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon> {{ project_details.is_archived ? 'Unarchive this Project' : 'Project Visibility' }}
                    </v-btn>

                    <div class="d-inline ml-6 caption info--text text--lighten-1">
                        <span>{{project_details.hide_for_user ? 'Hidden' : 'Visible'}} from the User's Dashboard</span>
                    </div>
                </div>

                <v-btn 
                    class="d-inline menu_bg_primary primary--text text--darken-1"
                    elevation=0
                    :loading="refreshing_project"
                    @click="refreshProject(project_details)">
                    <v-icon color="primary">mdi-refresh</v-icon>
                </v-btn>
            </v-card-actions>
        </div>
    </div>
</template>


<script>  
    import axios from "axios"
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment'
    import { safeParseJson } from '../helpers/safe-json'
    import { prepProjectData, setStatusData } from '../components/shared/projectFunctions'
    import { dataTimeDisplayFormatter } from './utilities'

    import ProjectData from './ProjectData'
    import ProjectFiles from './ProjectFiles'
    import ProjectPartnerDocs from './ProjectPartnerDocs'
    import ProjectDeliverables from './ProjectDeliverables'
    import UserData_Dashboard from './UserData_Dashboard.vue'
    import ModuleQuestionnaire from './ModuleQuestionnaire'
    import ActivityLogs from './ActivityLogs'
    import ProjectUsers from './ProjectUsers'
    import ProjectReport from './ProjectReport'
    import ProjectResources from './ProjectResources'
    import ProjectResolutions from './ProjectResolutions.vue'
    import EmpFilingData from './EmpFilingData.vue'
    import ProjectTeam from './ProjectTeam.vue'
    import VideoPlayer from './video'
    import DisableProject from './dialogs/DisableProject.vue'
    import { ExportToCsv } from 'export-to-csv'
    import { mdiTableRowHeight } from "@mdi/js"

    export default {
        name: 'ProjectDetails',

        components: {
            ProjectData,
            ProjectFiles,
            ProjectPartnerDocs,
            ProjectDeliverables,
            UserData_Dashboard,
            ModuleQuestionnaire,
            ActivityLogs,
            ProjectUsers,
            ProjectReport,
            ProjectResources,
            ProjectResolutions,
            EmpFilingData,
            ProjectTeam,
            DisableProject,
            VideoPlayer,
        },

        props: {
            user_id: String,
            project_id: String,
            client_info: Array,
            project_statuses: Array,
            projectDataDialog: Boolean,
            openTab: String,
            refreshProjects: Function,
            refreshUserProjects: Function,
        },

        computed: {
            questionnaire_completed_sections () {
                if (Array.isArray(this.project_details.questionnaire_sections) && this.project_details.questionnaire_sections.length > 0) {
                    return this.project_details.questionnaire_sections.filter(s => s.is_complete).length
                }

                const questionnaireProgress = this.project_details && this.project_details.questionnaire_progress
                    ? this.project_details.questionnaire_progress
                    : {}
                const finished = Number.parseInt(questionnaireProgress.finished, 10)
                return Number.isFinite(finished) && finished > 0 ? finished : 0
            },

            questionnaire_total_sections () {
                if (Array.isArray(this.project_details.questionnaire_sections) && this.project_details.questionnaire_sections.length > 0) {
                    return this.project_details.questionnaire_sections.length
                }

                const questionnaireProgress = this.project_details && this.project_details.questionnaire_progress
                    ? this.project_details.questionnaire_progress
                    : {}
                const finished = Number.parseInt(questionnaireProgress.finished, 10)
                const total = Number.parseInt(questionnaireProgress.total, 10)
                const normalizedFinished = Number.isFinite(finished) && finished > 0 ? finished : 0
                const normalizedTotal = Number.isFinite(total) && total > 0 ? total : 0
                return Math.max(normalizedTotal, normalizedFinished)
            },

            questionnaire_percentage () {
                const total = this.questionnaire_total_sections
                if (total <= 0) return 0

                return Math.ceil((this.questionnaire_completed_sections / total) * 100)
            },

            calculateResolutionsUsed () {
                if ( this.project_details.resolutions_data ) {
                    let totalResolutions = 0;
                    Object.keys(this.project_details.resolutions_data).forEach(key => {
                        totalResolutions += this.project_details.resolutions_data[key]
                    })
                    return totalResolutions
                } else {
                    return 0
                }
            }
        },

        data () {
            return {
                project_detail_view: this.openTab || 'overview',
                trigger_copied: false,
                project_details: {},
                user_data: {},
                date_menu: false,
                disableDialog: false,
                profileDialog: false,
                deliverableDialog: false,
                titleDialog: false,
                videoDialog: null,
                videoUrl: '',
                videoSrc: '',
                videoType: '',
                videoTitle: 'Resource Video',
                videoValid: null,
                dateMenu: false,
                archive_action: '',
                remove_project_id: '',
                remove_module_name: '',
                refresh_docs: false,
                refresh_partner_docs: false,
                refresh_delivs: false,
                refreshing_project: false,
                trigger_copied: false,
                noteArgs: {},
                available_buyer_listings: [],
                expressData: {},
                holdArgs: {},
                stepArgs: {},
                statusArgs: {},
                disableArgs: {},
                disable_action: '',
                buyerProject: [],
                entity_filing_status_list: [],
                annual_report_filing_status_list: [],
                report_type_options_list: [],
                moduleKey: '',
                moduleId: '',
                projectId: '',
                show_this: '',
                projectDeliverables: [],
                max100chars: [v => v.length <= 100 || 'Max 100 characters'],
                updateProject: {},
                showCompletedDate: false,
                readyToLoad: false,
                relatedProjectLoading: false,
                archiveWork: false,
                current_milliseconds: new Date().getTime(),
                resolution_cnt: 0,
                subProjects: [],
                resolutionStatuses: [
                    'open',
                    'processing',
                    'client_unresponsive',
                    'closed',
                    'review',
                    'complete'
                ],
                entityFilingModules: [
                    'entity-support-starter',
                    'entity-support-premium',
                    'entity-support-elite',
                    'entity',
                    "entity²",
                    'merger',
                    'merger-premium', 
                    'merger-elite'
                ],
            }
        },

        watch: {            
            openTab: {
                handler (val) {
                    this.projectView(val || 'overview')
                }
            },
            project_id: {
                handler(val){
                    if (val) {
                        this.projectDetails(this.user_id, this.project_id);
                    }
                }
            },
            project_detail_view: {
                handler (val) {
                    this.projectView(val)
                }
            },
            project_details: {
                async handler (val) {
                    if ( this.project_details.modinfo.module_key == 'entity-maintenance-program' ) {
                        this.subProjects = await this.getSubProjects(this.project_details.project_id)
                        this.resolution_cnt = this.calculateResolutionsUsed
                    }
                },
                deep: true
            },
            'project_details.questionnaire_locked': function (newValue, oldValue) {
                // Only run the function if the value has actually changed
                if ( oldValue !== undefined && newValue !== oldValue ) {
                    this.triggerUserFeedback( true, `The questionnaire has been ${ newValue ? 'locked' : 'unlocked' }.` );
                }
            },
        },

        created () {
            this.projectDetails(this.user_id, this.project_id);
        },

        mounted () {
            this.projectView(this.openTab || 'overview')
        },
        
        methods: {
            closeProject: function ( val ) {
                this.readyToLoad = false
                this.$emit('closeDetailDialog', false)
                this.projectView('overview')
                this.$emit('refreshUserProjects', val || true)
            },

            navigateToRelatedProject: async function ( projectRef ) {
                if ( !projectRef || !projectRef.user_id || !projectRef.project_id || this.relatedProjectLoading ) return

                try {
                    this.relatedProjectLoading = true
                    await new Promise(resolve => setTimeout(resolve, 500))
                    await this.projectDetails(projectRef.user_id, projectRef.project_id)
                } finally {
                    this.relatedProjectLoading = false
                }
            },
            
            projectView: async function (view) {
                this.$feedback.hide();
                this.project_detail_view = view
            },

            triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='light-green' ) {
                this.$feedback.trigger( feedback_trigger, feedback_message, feedback_color );
            },
            
            handleCopyProjectId: function ( id ) {
                navigator.clipboard.writeText(document.querySelector(`span#copy-pid-${id}`).innerText.trim())
                this.trigger_copied = true;
                setTimeout(() => { this.trigger_copied = false; }, 3000);
            },

            openQuestionnaire: function ( prj ) {
                this.moduleKey = prj.modinfo.module_key
                this.projectId = prj.project_id
                this.moduleId = prj.module_id

                setTimeout(()=>{ 
                    this.profileDialog = true 
                }, 1000)
            },
            closeQuestionnaire: function () {
                this.profileDialog = false
            },

            getQuestionnaireSnapshot: function ( projectData ) {
                if ( !projectData || typeof projectData !== 'object' ) return {}

                const questionnaireKeys = [
                    'answers',
                    'answer_data',
                    'questionnaire_answers',
                    'questionnaire_data',
                    'q_and_a',
                    'qa_data',
                    'questionnaire'
                ]

                const snapshot = {}
                questionnaireKeys.forEach((key) => {
                    if ( projectData[key] !== undefined ) snapshot[key] = projectData[key]
                })

                return snapshot
            },

            applyQuestionnaireSnapshot: function ( projectData, questionnaireSnapshot ) {
                if ( !questionnaireSnapshot || !Object.keys(questionnaireSnapshot).length ) return projectData
                return Object.assign({}, projectData, questionnaireSnapshot)
            },

            applyQuestionnaireProgressUpdate: function ( payload ) {
                if ( !payload || !this.project_details ) return

                const incomingProgress = payload.questionnaire_progress && typeof payload.questionnaire_progress === 'object'
                    ? payload.questionnaire_progress
                    : null

                if ( incomingProgress ) {
                    this.project_details.questionnaire_progress = {
                        ...(this.project_details.questionnaire_progress || {}),
                        ...incomingProgress
                    }
                }

                if ( Array.isArray(payload.questionnaire_sections) ) {
                    this.project_details.questionnaire_sections = payload.questionnaire_sections
                }

                if ( typeof payload.status === 'string' && payload.status ) {
                    this.project_details.status = payload.status
                    this.showCompletedDate = payload.status === 'complete'
                }

                if ( payload.date_submitted !== undefined ) {
                    this.project_details.date_submitted = payload.date_submitted
                }
            },

            projectDetails: async function ( userId , projectId, options = {} ) {
                const { preserveQuestionnaireAnswers = false } = options
                const questionnaireSnapshot = preserveQuestionnaireAnswers ? this.getQuestionnaireSnapshot(this.project_details) : {}

                try {
                    await this.getLists();
                    const current_project = await axios.get(`${appUrls.api}/api/admin/current_project/${userId}/${projectId}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    
                    if ( current_project.data.outcome ) {
                        const refreshedProjectData = preserveQuestionnaireAnswers
                            ? this.applyQuestionnaireSnapshot(current_project.data.project_data, questionnaireSnapshot)
                            : current_project.data.project_data

                        this.project_details = refreshedProjectData
                        const projectUsers = Array.isArray(this.project_details.users) ? this.project_details.users : []
                        this.user_data = projectUsers.filter( usr => usr.user_type == 'owner' )
                        this.showCompletedDate = this.project_details.status == 'complete'
                        this.readyToLoad = true
                        return true
                     } else {
                        this.triggerUserFeedback( true, current_project.data.message, 'accent' );
                        return false
                    }
                } catch ( error ) {
                    console.log(error);
                    return false
                }
            },

            openProjectTitle: function ( prj ) {
                this.titleDialog = true
                this.updateProject = prj
            },

            questionnaireLocking: async function ( project ) {
                try {
                    const questionnaire_lock_rs = await axios.put(`${appUrls.api}/api/admin/project_questionnairelock`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            project,
                            lock: !project.questionnaire_locked
                    })

                    if( questionnaire_lock_rs.data ) {
                        this.projectDetails( project.user_id, project.project_id );
                    }

                } catch ( error ) {
                    console.log(error);
                }
            },

            updateECD: function ( data ) {
                this.estCompletionDate( data.user_id, data.project_id, data.close_date);
            },
            
            expediteProject: async function ( project ) {
                try {
                    const expedite_project_rs = await axios.put(`${appUrls.api}/api/admin/project_expedite`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project
                    })

                    this.triggerUserFeedback( true, expedite_project_rs.data.message )

                } catch ( error ) {
                    console.log(error);
                }
            },

            updateProjectTitle: async function ( project ) {
                try {
                    const add_project_title_rs = await axios.put(`${appUrls.api}/api/admin/internal_project_title`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project
                    })

                    if ( add_project_title_rs.data.outcome ) this.titleDialog = false
                    this.triggerUserFeedback( true, add_project_title_rs.data.message )

                } catch ( error ) {
                    console.log(error);
                }
            },

            getLists: async function () {
                try {
                    let optionsLists = [ 
                        {'name': 'entity_filing_status', 'type': 'txt'},
                        {'name': 'admin_document_status', 'type': 'txt'},
                        {'name': 'filing_statuses', 'type': 'txt'},
                        {'name': 'report_type_options', 'type': 'txt'},
                    ];

                    const get_lists = await axios.post(`${appUrls.api}/api/lists`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        list_options: optionsLists
                    })

                    if ( get_lists.data.outcome ) {
                        this.arrLists = get_lists.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in this.arrLists) {
                            if (this.arrLists[l].name == 'entity_filing_status') this.entity_filing_status_list = this.arrLists[l].list
                            if (this.arrLists[l].name == 'admin_document_status') this.admin_document_status_list = this.arrLists[l].list
                            if (this.arrLists[l].name == 'filing_statuses') this.annual_report_filing_status_list = this.arrLists[l].list
                            if (this.arrLists[l].name == 'report_type_options') this.report_type_options_list = this.arrLists[l].list
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                };
            },

            saveProject: async function ( stepArgs ) {
                stepArgs.prj.steps_completed = stepArgs.step.is_independent ?
                    stepArgs.prj.steps_completed :
                    stepArgs.step.completed_val ? (stepArgs.prj.steps_completed + 1) : (stepArgs.prj.steps_completed - 1);

                stepArgs.prj.complete = Math.round(((stepArgs.prj.steps_completed / stepArgs.prj.modinfo.steps_to_complete) * 100)) > 100 ? 100 : Math.round(((stepArgs.prj.steps_completed / stepArgs.prj.modinfo.steps_to_complete) * 100));

                if ( stepArgs.prj.complete == 100 ) {
                    stepArgs.prj.status = 'complete'
                    const this_newDate = new Date()
                    stepArgs.prj.close_date = String(String(this_newDate.getFullYear()).concat('-',this_newDate.getMonth()+1).padStart(2, '0').concat('-', String(this_newDate.getDate()).padStart(2, '0')))
                    this.showCompletedDate = true
                } else if ( stepArgs.prj.complete < 100 ) {
                    switch ( stepArgs.prj.steps_completed ) {
                        case 0: stepArgs.prj.status = 'open'; break;
                        case 1: stepArgs.prj.status = 'review'; break;
                        default: stepArgs.prj.status = 'processing'; break;
                    }
                    this.showCompletedDate = false
                }

                const status_data = await setStatusData( stepArgs.prj.status, this.project_statuses )
                stepArgs.prj.status_internal_label  = status_data.status_internal_label
                stepArgs.prj.status_color           = status_data.status_color
                stepArgs.prj.status_text_color      = status_data.status_text_color
                stepArgs.prj.status_progress_color  = status_data.status_progress_color

                const project_saved = await this.saveProjectProgress( stepArgs )
                if ( project_saved ) { 
                    this.projectDetails( stepArgs.prj.user_id, stepArgs.prj.project_id );
                }
            },

            thisProjectDetail: async function ( pid, uid ) {
                try {
                    const current_project = await axios.get(`${appUrls.api}/api/admin/current_project/${uid}/${pid}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    
                    if ( current_project.data.outcome ) {
                        this.project_details = current_project.data.project_data;
                    } else {
                        this.$feedback.error( current_project.data.message );
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            initDisableProject: async function ( prj ) {
                this.disableDialog = true
                const archive_action = prj.is_archived ? 'unarchive' : ''
                const project_status = prj.status
                const hide_project   = prj.hide_for_user

                this.disableArgs = { 
                    remove_project_id: prj.project_id, 
                    remove_module_name: prj.modinfo.module_name, 
                    archive_action: archive_action,
                    project_status: project_status,
                    hide_for_user: hide_project
                }
            },

            closeDisableDialog: function ( archiveWork ) {
                this.archiveWork = archiveWork
                this.disableDialog = false
            },

            refreshProject: async function ( prj ) {
                try {
                    this.refreshing_project = true
                    const refreshed = await this.projectDetails(prj.user_id, prj.project_id, { preserveQuestionnaireAnswers: true })

                    if ( refreshed ) {
                        this.triggerUserFeedback( true, 'Project data has been refreshed');
                    }

                } catch ( error ) {
                    console.log(error);
                } finally {
                    this.refreshing_project = false
                }
            },

            exportAnswers: async function ( project_details ) {
                try {
                    const export_prj_data_rs = await axios.post(`${appUrls.api}/api/admin/export_data`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        moduleKey: project_details.modinfo.module_key,
                        projectId: project_details.project_id,
                        userId: project_details.user_id,
                        parentProjectId: project_details.parent_project_id
                    })

                    if ( export_prj_data_rs.data.outcome ){
                        this.triggerUserFeedback( true, export_prj_data_rs.data.message );

                        const this_fileData = new Buffer(export_prj_data_rs.data.buf, 'base64');
                        const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        const this_fileName = export_prj_data_rs.data.basic_data.file_name+'.'+export_prj_data_rs.data.basic_data.output_type;
                        
                        const this_blob = new Blob([this_fileData], {type: this_fileType});
                        saveAs(this_blob, this_fileName);

                    } else {
                        this.triggerUserFeedback( true, export_prj_data_rs.data.message, 'accent' );
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            pullProjectDocs: async function ( project_details, doc_type ) {
                try {
                    this.refresh_docs = doc_type == 'client' ? true : false
                    this.refresh_partner_docs = doc_type == 'partner' ? true : false

                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/false`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    setTimeout(() => {
                        project_details.docs = pulled_files.data.files.filter( file => file.is_revision == false);
                        project_details.revs = pulled_files.data.files.filter( file => file.is_revision == true);
                        project_details.partner_docs = pulled_files.data.files.filter( file => file.is_partner == true);
                        this.refresh_docs = false
                        this.refresh_partner_docs = false
                        this.refreshProject(project_details)
                    }, 2000)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            pullProjectDelivs: async function ( project_details ) {
                console.log('pulling delivs for project ', project_details.project_id)
                try {
                    this.refresh_delivs = true
                    const pulled_files = await axios.post(`${appUrls.api}/api/pull_files/${project_details.project_id}/true`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    project_details.dlvs = pulled_files.data.files;
                    this.refresh_delivs = false
                    this.refreshProject(project_details)
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            toggleVisiblity: async function ( project_data, type ) {
                try {

                    const resource_vis = await axios.post(`${appUrls.api}/api/admin/update_resource_visibility/${type}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project_data
                    })

                    if ( resource_vis.data.outcome ) this.project_details.resource_visibility = resource_vis.data.project.resource_visibility
                    this.triggerUserFeedback( true, resource_vis.data.message )

                } catch ( error ) {
                    console.log(error)
                }
            },

            playResourceVideo: async function ( data ) {
                this.videoDialog = true
                this.videoUrl   = data.url
                // https://mycompass-production.s3.us-west-2.amazonaws.com/resource_files/Introduction%20Video.mp4?
                // X-Amz-Algorithm=AWS4-HMAC-SHA256&
                // X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&
                // X-Amz-Credential=AKIAXMOUSJ6P5QSDNUMA%2F20250723%2Fus-west-2%2Fs3%2Faws4_request&
                // X-Amz-Date=20250723T164445Z&
                // X-Amz-Expires=259200&
                // X-Amz-Signature=9939f9345861ac75ba6d5d847b9b8f75a0d14bf61ff5d9b03c05de4b9ff4e545&
                // X-Amz-SignedHeaders=host&
                // x-amz-checksum-mode=ENABLED&
                // x-id=GetObject
                this.videoValid = await this.videoValidation( this.videoUrl )

                if ( this.videoValid ) {
                    this.videoId     = data.fileid
                    this.videoSrc    = data.url.includes('vimeo') ? 'Vimeo' : 'AWS'
                    this.videoTitle  = data.title
                    this.videoType   = data.type
                }
            },

            videoValidation: async function ( videoUrl ) {
                try {
                    if ( videoUrl.includes('vimeo') ) return true

                    const video_params = new URLSearchParams(videoUrl.split('?')[1]);
                    const signature = video_params.get('X-Amz-Signature') || video_params.get('Signature') || false // S3 OR CLOUDFRONT SIGNED URL
                    const expires = video_params.get('X-Amz-Expires') || video_params.get('Expires') || false
                    const today = Date.now()

                    return signature != false && expires != false && today >= expires
                } catch (error) {
                    // console.log('error', error.response)
                    return false
                }
            },

            closeVideo () {
                this.videoDialog = null
                this.videoValid  = null
                this.videoId     = ''
                this.videoSrc    = ''
                this.videoUrl    = ''
                this.videoType   = ''
                this.videoTitle  = 'Resource Video'
            },

            refreshUsers: async function ( projectId, message_override='' ) {
                try {
                    const project_users = await axios.get(`${appUrls.api}/api/project_users/${projectId}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                
                    this.project_details.users = project_users.data.users

                    const feedback_msg = message_override != '' ? message_override : project_users.data.message
                    this.triggerUserFeedback( true, feedback_msg);
                    // this.pullActivityLogs(this.project_details)
                
                } catch ( error ) {
                    console.log(error);
                    this.triggerUserFeedback( true, error, 'accent' );
                }
            },

            saveProjectProgress: async function ( data ) {
                try {
                    // FILTER ONLY RELEVANT DATA
                    const [project_data, process_data] = prepProjectData( data )
                    
                    const update_project = await axios.post(`${appUrls.api}/api/admin/update_current_project`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project: project_data,
                        progress: process_data
                    })
                    
                    if ( update_project.data.outcome ) {
                        this.triggerUserFeedback( true, update_project.data.message );

                        return true
          }
                } catch ( error ) {
                    console.log(error);
                    return false
                }
            },

            estCompletionDate: async function ( uid, pid, date ) {
                try {
                    const project_ecd = await axios.put(`${appUrls.api}/api/admin/project_ecd`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        user_id: uid,
                        project_id: pid,
                        ecd: date
                    })

                    if(project_ecd.data.outcome){                        
                        this.triggerUserFeedback( true, project_ecd.data.message);

                        setTimeout(() => {
                            this.projectDetails( uid, pid );
                        }, 2000)
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            flagProjectAsTest: async function ( project ) {
                try {
                    const test_flag_rs = await axios.put(`${appUrls.api}/api/admin/test_project_flag`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        project
                    })

                    if ( test_flag_rs.data.outcome ) {
                        this.project_details = test_flag_rs.data.project_data
                        this.triggerUserFeedback( true, test_flag_rs.data.message);
                    }

                } catch ( error ) {
                    console.log(error);
                }
            },

            handleCopyEmail: function () {
                navigator.clipboard.writeText(document.querySelector('div#copy-email').innerText.trim())
                this.trigger_copied = true;
                setTimeout(() => { this.trigger_copied = false; }, 3000);
            },

            formatThisDate: function ( date, options, iso_format=false ) {
                if (!date) return false;

                const defaultOptions = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }
                return dataTimeDisplayFormatter(date, options ? options : defaultOptions, iso_format )
            },

            gatherInitialQuestionnaire: async function (parentProjId) {
                const dataObj = {}
                const res = await axios.get(`${appUrls.api}/api/user_data/${parentProjId}`, {
                  headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                })

                for (const { section, question, value_type, answer } of res.data.values) {
                  const key = `${section}_${question}`

                                    if (value_type === 'object' && answer != '') {
                                        dataObj[key] = safeParseJson(answer, answer)
                  } else {
                    dataObj[key] = answer
                  }
                }
                return dataObj
            },

            getSubProjects: async function (projectId) {
                try {
                    const response = await axios.post(`${appUrls.api}/api/admin/sub_projects`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        data: {
                            project_id: projectId
                        }
                    })

                    if (!response.data.subProjects) return []

                    return response.data.subProjects.sort((a, b) => new Date(a.date_initialized) - new Date(b.date_initialized))
                } catch (error) {
                    console.log("Error getting subProjects: ", error)
                }
            },

            gatherResolutionData: async function (projId) {
                const dataObj = {}
                const res = await axios.get(`${appUrls.api}/api/user_data/${projId}`, {
                  headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                })

                for (const { section, question, value_type, answer } of res.data.values) {
                  const key = `${section}_${question}`

                                    if (value_type === 'object' && answer != '') {
                                        dataObj[key] = safeParseJson(answer, answer)
                  } else {
                    dataObj[key] = answer
                  }
                }

                return dataObj
            },

            // generateResolutionPdf: async function (project_details) {
            //     const resolutionData = await this.gatherResolutionData(project_details.project_id)
            //     const questionnaireData = await this.gatherInitialQuestionnaire(project_details.parent_project_id)
            //     const res = await axios.post(`${appUrls.api}/api/resolution_export`, {
            //       headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
            //       data: {
            //         resolutionData,
            //         questionnaireData
            //       }
            //     })
            //     .then( res => {
            //         if(res.data.outcome){  
            //           console.log("res", res)
            //         }
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //     });

            // }
            exportResolutionData: async function (project_details) {
              const resolutionData = await this.gatherResolutionData(project_details.project_id)
              const questionnaireData = await this.gatherInitialQuestionnaire(project_details.parent_project_id)
              return await axios.post(`${appUrls.api}/api/admin/resolution_export`, {
                headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                data: {
                  resolutionData,
                  questionnaireData
                }
              })
              .then(res => {
                // console.log(res.data)
                  const options = {
                    fieldSeparator: ',',
                    quoteStrings: '"',
                    decimalSeparator: '.',
                    useTextFile: false,
                    useBom: true,
                    useKeysAsHeaders: true,
                  };

                  const csvExporter = new ExportToCsv(options);

                  csvExporter.generateCsv(res.data.csvExport);
              })
              .catch(function (error) {
                console.log(error);
              });
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bg_pewter {
        background-color: #E9EAEC !important;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .header_bg_color {
        font-size: 1.15em !important;
        background-color: var(--v-primary-darken1)
    }
    .header_text_small {
        font-size: .9em !important;
    }
    .header_text_big {
        font-size: 1.1em !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 3rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .refresh_response {
        font-size: .8rem;
    }
    .click_indicator {
		width: 50px; 
		height: 3px; 
		border-top: 1px dotted rgba(0,0,0,.3);
		border-bottom: 1px dotted rgba(0,0,0,.3);
	}
    .user_link {
        text-decoration: none;
    }
    .user_link:hover {
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/ProjectDetails.vue